export default {
    ORDER_QRCODE_ADMIN_VERIFY_SUCCESS: '憑證使用成功',
}
